import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';
import { ForceRouteReloadService } from './force-route-reload.service';

// Angular's own default reuse strategy (BaseRouteReuseStrategy), with an escape hatch for
// AppComponent's account/impersonation-changed handling: while ForceRouteReloadService is active,
// no route is reused, so the current route's components are destroyed and recreated (rerunning
// ngOnInit) instead of the default behaviour of reusing them when the route config is unchanged.
@Injectable()
export class ForceReloadRouteReuseStrategy extends BaseRouteReuseStrategy {
	constructor(private forceRouteReloadService: ForceRouteReloadService) {
		super();
	}

	override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		if (this.forceRouteReloadService.isActive) {
			return false;
		}
		return super.shouldReuseRoute(future, curr);
	}
}
